export const product: object = {
  productDetails: {
    atAGlance: 'Auf einen Blick',
    benefits: 'Vorteile',
    benefitsAndFeatures: 'Vorteile und Merkmale',
    category: 'Kategorie',
    collapseAll: 'Alles zusammenklappen',
    compliance: 'Compliance',
    contactSupport: 'Kontakt Support',
    contactSupportDescription: 'Erstellen Sie ein Support-Ticket, um Hilfe bei einer Frage oder einem Problem zu erhalten.',
    chatNow: 'Jetzt chatten',
    chatNowDescription: 'Chatten Sie mit einem SAP-Mitarbeiter, um Live-Hilfe zu erhalten.',
    chatUnavailable: 'Chat derzeit nicht verfügbar',
    chatUnavailableDescription: 'Chatten Sie mit einem SAP-Vertreter, um Live-Hilfe zu erhalten.',
    howCanHelp: 'Wie können wir helfen?',
    haveQuestion: 'Eine Frage haben?',
    contactUs: 'Kontakt',
    deployment: 'Entfaltung',
    expandAll: 'Alle erweitern',
    features: 'Merkmale',
    first: 'Erster',
    freeTrial: 'Freier Versuch',
    from: 'von',
    general: 'General',
    globalization: 'Globalisierung',
    lessBenefits: 'Weniger Vorteile',
    lessFeatures: 'Weniger Merkmale',
    lessResources: 'Weniger Ressourcen',
    monthly: 'Monatlich',
    moreBenefits: 'Mehr Vorteile',
    moreFeatures: 'Mehr Funktionen',
    moreResources: 'Mehr Ressourcen',
    next: 'Nächster',
    oneTime: 'Einmalig',
    operations: 'Operationen',
    per: 'pro',
    privacyStatement: 'Datenschutzerklärung',
    readPdf: 'PDF lesen',
    resources: 'Ressourcen',
    security: 'Sicherheit',
    supportPage: 'Support-Seite',
    technicalInformation: 'Technische Informationen',
    providedByPublisher: 'Die in diesem Abschnitt enthaltenen Informationen werden vom Herausgeber bereitgestellt.',
    termsAndConditions: 'Bedingungen und Konditionen',
    visitWebsite: 'Website besuchen',
    allProducts: 'Alle Produkte',
    id: 'ID',
    quantity: 'Anz',
    productDetails: 'Produkt Details',
    productLogo: 'Produkt logo',
    certification: 'Zertifizierung',
    freeTrialAvailable: 'Freier versuch',
    productName: 'Produktname',
    productDetailsPage: 'Product details page for {{productName}}',
    teaserText: 'Teaser text',
    pricingDetails: 'Preisdetails',
    tieredPricing: 'Preisstaffelung',
    scaleDiscount: 'Skalenrabatt',
    perAmountOfUnit: 'Je {{amount}} {{unit}}:',
    allPlansInclude: 'Alle Tarife beinhalten',
    fixPrice: 'Festpreis:',
    perUnit: 'Je {{unit}}',
    cancellationFee: 'Aufkündigung',
    pricePerAmountOfUnitsPerPeriod: 'Preis je {{amount}} {{unit}} je {{period}}',
    pricePerUnitPerPeriod: 'Preis je {{unit}} je {{period}}',
    priceUponRequest: 'Preis auf Nachfrage',
    priceNotAvailable: 'Preis aktuell nicht verfügbar',
    sapProduct: 'SAP Produkt',
    specification: 'Specs',
    shipping: 'Versand',
    share: 'Teilen',
    showReviews: 'Bewertungen anzeigen',
    plansAndPricing: 'Tarife und Preise',
    pricing: 'Preise',
    cta: {
      trial: 'Testversion Anfordern',
      buy: 'Angebot Anfordern',
      rfi: 'Nachricht Senden',
      upsell: 'Zusatzkauf',
      upgrade: 'Upgrade',
      manageOrders: 'Support Kontaktieren',
    },
    termsConditions: {
      printTermsButton: 'Drucken',
      closePrintTermsButton: 'Schließen'
    },
    by: 'von',
    viewAll: 'Alle ansehen',
    includes: 'Beinhaltet',
    unlimited: 'unbeschränkte',
    minDuration: '{{min}} {{unit}} min. Vertragslaufzeit',
    maxDuration: '{{max}} {{unit}} max. Vertragslaufzeit',
    minMaxDuration: '{{min}} bis {{max}} {{unit}} Vertragslaufzeit',
    publisher: 'Herausgeber',
    askPublisher: 'Herausgeber fragen',
    askPublisherDescription: 'Wenden Sie sich an den Herausgeber, um nach dieser Lösung zu fragen.',
    askSapStore: 'SAP Store fragen',
    askSapStoreDescription: 'Holen Sie sich Hilfe bei Fragen zur Website, bei der Fehlerbehebung oder bei allem anderen.',
    viewPublisherInformation: 'Mehr Informationen',
    publisherSolutions: 'Alle Lösungen anzeigen',
  },
  productList: {
    filterBy: {
      label: 'Filter by',
      action: 'Filter by',
    },
    appliedFilter: 'Applied Filter:',
    showLess: 'Show less...',
    showMore: 'Show more...',
    sortByRelevance: 'Sort by Relevance',
    backToTopBtn: 'BACK TO TOP',
    showMoreBtn: 'SHOW MORE',
  },
  productFacetNavigation: {
    filterBy: {
      label: 'Filter by',
      action: 'Filter by',
    },
    appliedFilter: 'Applied Filter:',
    showLess: 'Show less...',
    showMore: 'Show more...',
    sortByRelevance: 'Sort by Relevance',
  },
  productSummary: {
    id: 'ID',
    showReviews: 'Show reviews',
    share: 'Share',
  },
  productReview: {
    reviewCount: '({{count}} Bewertungen)',
    reviewCountEmpty: '({{count}})',
    overallRating: 'Overall Rating',
    reviewTitle: 'Review Title',
    writeYourComments: 'Write your comments',
    rating: 'Rating',
    reviewerName: 'Reviewer name (optional)',
    writeReview: 'Write a Review',
    more: 'More',
    less: 'Less',
    thankYouForReview:
      'Thank you for the review! Note that reviews may require review before appearing here.',

    beTheFirstToReview: 'Seien Sie der erste, der seine Gedanken zu dieser Lösung mitteilt',
    chatBubbleOrange: 'Orangene Sprechblasen',
    continueToG2Crowd: 'Zu G2.com',
    empty: 'leerer',
    half: 'halb',
    filled: 'gefüllter',
    G2Com: 'G2.com',
    G2CrowdRedirect: 'Sie werden zur Bewertungs- und Beurteilungsseite G2Crowd weitergeleitet.',
    outOf5Stars: 'von 5 Sternen',
    reviews: 'Bewertungen',
    reviewsCollectedAndHosted: 'Die Bewertungen werden gesammelt und bereitgestellt von',
    star: 'Stern',
    readThisReviewOnG2: 'Lies diese Bewertung auf G2.com.',
    verifiedReviewer: 'Verifizierter Rezensent',
    writeAReview: 'Bewerten Sie',
    writeAReviewUppercase: 'Bewerten Sie dieses Produkt',
    readAReview: 'Lesen Sie die ganze Bewertung',
  },
  addToCart: {
    itemsAddedToYourCart: 'Ihrem Warenkorb hinzugefügte(r) Artikel',
    itemsIncrementedInYourCart: 'Dieser Artikel war bereits in Ihrem Warenkorb. Die Menge wurde aktualisiert.',
    items: 'Artikel',
    updatingCart: 'Warenkorb aktualisieren',
    addToCart: 'Zum Warenkorb hinzufügen',
    updateCart: 'Warenkorb aktualisieren',
    viewCart: 'Warenkorb anzeigen',
    proceedToCheckout: 'weiter zur Kasse',
    quantity: 'Menge',
    outOfStock: 'Vergriffen',
    inStock: 'Auf Lager',
  },
  CMSTabParagraphContainer: {
    tabs: {
      ProductDetailsTabComponent: 'Product Details',
      ProductSpecsTabComponent: 'Specs',
      ProductReviewsTabComponent: 'Reviews',
      deliveryTab: 'Shipping',
    },
  },
};
